import './Card.scss';
import React from 'react';
import { mergeSx } from '../_internal/styleProps';

function Card({
  actions,
  children,
  className = '',
  compact = false,
  footer,
  header,
  interactive = false,
  onClick,
  padding = 'medium',
  selected = false,
  style,
  sx,
  tabIndex,
  ...rest
}) {
  const isClickable = Boolean(onClick);
  const handleKeyDown = (event) => {
    if (!isClickable || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    onClick(event);
  };

  return (
    <div
      className={[
        'custom-card',
        `custom-card--padding-${padding}`,
        interactive || isClickable ? 'custom-card--interactive' : '',
        compact ? 'custom-card--compact' : '',
        selected ? 'selected' : '',
        className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={isClickable ? 'button' : undefined}
      tabIndex={tabIndex ?? (isClickable ? 0 : undefined)}
      style={mergeSx(sx, style)}
      {...rest}
    >
      {(header || actions) && (
        <div className="custom-card__header">
          <div>{header}</div>
          {actions && <div className="custom-card__actions">{actions}</div>}
        </div>
      )}
      <div className="custom-card__body">{children}</div>
      {footer && <div className="custom-card__footer">{footer}</div>}
    </div>
  );
}

export default Card;
